<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
    <v-dialog v-model="showDialog" width="600" persistent>
      <v-card class="pb-3 pt-0">
        <v-title class="headline">{{ title }}</v-title>
        <v-card-text class="subtitle-1 pb-0 pt-4">
          <div v-if="isInvalid">
            <p>
              No match found for
              <!-- <span class="font-weight-bold">"{{ fullAddress.formatted_address }}"</span>. -->
            </p>
            <div v-if="isValidated">
              <p class="mb-1 font-weight-bold">
                Cannot validate address. Invalid parameter/s:
              </p>
              <!-- <p class="my-0" v-for="item in invalidItems" :key="item.name">{{ item }}</p> -->
            </div>
            <p class="mt-4">
              Please provide the following details and notify the customer.
            </p>
          </div>
          <p v-else>Please provide the following details:</p>

          <v-layout wrap>
            <v-flex v-show="isAdmin || isUserMember" sm6 md6 lg6 class="px-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="Customer Name"
                :rules="isAdmin || isUserMember ? 'required' : ''"
              >
                <v-text-field
                  v-model="customerName"
                  label="Customer Name"
                  type="text"
                  name="customerName"
                  autocomplete="new"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex v-show="isAdmin" sm6 md6 lg6 class="px-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="Customer Email"
                :rules="isAdmin || isUserMember ? 'required|email' : ''"
              >
                <v-text-field
                  v-model="customerEmail"
                  label="Customer Email"
                  type="text"
                  name="customerEmail"
                  autocomplete="new"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex sm6 md6 lg6 class="px-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="Street Address"
                rules="required"
              >
                <v-text-field
                  v-model="streetAddress"
                  label="Street Address"
                  type="text"
                  name="streetAddress"
                  autocomplete="new"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex sm6 md6 lg6 class="px-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="Suburb"
                rules="required"
              >
                <v-text-field
                  v-model="suburb"
                  label="Suburb"
                  type="text"
                  name="suburb"
                  autocomplete="new"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex sm6 md6 lg6 class="px-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="State"
                rules="required"
              >
                <v-text-field
                  v-model="state"
                  label="State"
                  name="state"
                  autocomplete="new"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex sm6 md6 lg6 class="px-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="Postcode"
                rules="required"
              >
                <v-text-field
                  v-model="postcode"
                  label="Postcode"
                  type="text"
                  name="postcode"
                  autocomplete="new"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions class="mt-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-3 primary"
            :disabled="invalid || !dirty"
            @click="isAdmin || isUserMember ? sendEmail() : createTicket()"
          >
            {{
              isAdmin || isUserMember ? 'Send Email' : 'Create Support Ticket'
            }}
          </v-btn>
          <v-btn @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <message-alert
      :component="$store.getters['orders/sqAddress/message']"
    ></message-alert>
  </ValidationObserver>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MessageAlert from '../MessageAlert.vue';
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);
const { mapActions: mapSQAddressActions } =
  createNamespacedHelpers(`orders/sqAddress`);

export default {
  components: { MessageAlert },
  name: 'InvalidAddress',
  props: {
    showDialog: { type: Boolean, required: true },
    invalidItems: { type: Array, required: true },
    isInvalid: { type: Boolean, required: true },
    title: { type: String, required: true },
    isValidated: { type: Boolean, required: true },
  },
  computed: {
    ...mapOrderGetters(['isAdmin', 'isUserMember']),
  },
  data: () => ({
    streetAddress: '',
    suburb: '',
    state: '',
    postcode: '',
    customerEmail: '',
    customerName: '',
  }),
  methods: {
    ...mapSQAddressActions(['createTemplatedEmail', 'createSupportTicket']),
    closeDialog() {
      this.$refs.observer.reset();
      this.$emit('close');
    },
    sendEmail() {
      let vm = this;
      let payload = {
        to: vm.customerEmail,
        bcc: '',
        mobile: '',
        toName: vm.customerName,
        addressDetails: {
          streetAddress: vm.streetAddress,
          suburb: vm.suburb,
          state: vm.state,
          postcode: vm.postcode,
        },
      };
      vm.$emit('toggleLoading', true);
      vm.createTemplatedEmail(payload)
        .then(() => {
          vm.$emit('toggleLoading', false);
          vm.reset();
          vm.$emit('close');
        })
        .catch((err) => {
          vm.$emit('toggleLoading', false);
        });
    },
    createTicket() {
      let vm = this;
      let payload = {
        customerName: '',
        customerEmail: '',
        type: 0,
        address: {
          streetAddress: vm.streetAddress,
          suburb: vm.suburb,
          state: vm.state,
          postcode: vm.postcode,
        },
      };
      vm.$emit('toggleLoading', true);
      vm.createSupportTicket(payload)
        .then(() => {
          vm.$emit('toggleLoading', false);
          vm.reset();
          vm.$emit('close');
        })
        .catch((err) => {
          vm.$emit('toggleLoading', false);
        });
    },
    closeDialog() {
      let vm = this;
      vm.reset();
      vm.$emit('close');
    },
    reset() {
      let vm = this;
      vm.streetAddress = '';
      vm.suburb = '';
      vm.state = '';
      vm.postcode = '';
      vm.customerEmail = '';
      vm.customerName = '';
      vm.$refs.observer.reset();
    },
  },
};
</script>

<style lang="scss" scoped></style>
